module.exports = __webpack_public_path__ + "static/media/DuplicateSlab-BoldItalic.55151026.woff";